import { cn } from '../lib/cn.js'

/**
 * Индикатор ожидания. Намеренно тихий: в админке он появляется часто,
 * и мигающий яркий элемент на каждом обновлении списка утомляет.
 *
 * Уважает prefers-reduced-motion: при включённой настройке вращение
 * заменяется статичной меткой, а не пропадает совсем — сигнал «идёт
 * работа» должен остаться.
 */
export function Spinner({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <span
      role="status"
      aria-label="Загрузка"
      className={cn(
        'inline-block shrink-0 rounded-full border-2 border-current border-t-transparent',
        'motion-safe:animate-spin motion-reduce:opacity-50',
        className,
      )}
      style={{ width: size, height: size }}
    />
  )
}
